import React from 'react'
import RDLogo from '../img/redDevilLogo.png'
const Home = () => {
  return (
    <div className='container-fluid min-vh-100 bg-dark d-flex align-items-center'>
        <div className='container text-center text-white'>

            <h1>Manchester United API Project</h1>
            <h2>A react js project that will turn you into a Red Devil:</h2>
                <ul className='list-unstyled'>
                    <li>United's positon on the Table</li>
                    <li>Learn about the United Players</li>
                    <li>The games United has won, drawn, and lost</li>
                    <li>United's fixtures for the entire 2022/2023 season</li>
                </ul>
            <h2>Now you are a Real Red Devil!</h2>
            <img src={RDLogo} className='img-fluid' width="100px"  alt="illustration of Fred the Red" />

        </div>
     
    </div>
  )
}

export default Home